﻿import $ from 'jquery';
import 'jstorage';

export class Storage {
  public static set(key: string, value: any, millisecondsToLive?: number): any {
    if (millisecondsToLive) {
      return $.jStorage.set(key, value, { TTL: millisecondsToLive });
    }
    return $.jStorage.set(key, value);
  }
  public static get(key: string): any {
    return $.jStorage.get(key);
  }
  public static remove(key: string): boolean {
    return $.jStorage.deleteKey(key);
  }
  public static clear(): void {
    $.jStorage.flush();
  }
  public static setChangeListener(key: string, callback: (key: string, action: any) => void): void {
    $.jStorage.listenKeyChange(key, callback);
  }
  public static removeOnChangeListener(key: string, callback?: () => void): void {
    $.jStorage.stopListening(key, callback);
  }
}

export default Storage;